// extracted by mini-css-extract-plugin
export default {"borderless":"ATMIcon_borderless__cxvcS"};